/* eslint-disable @typescript-eslint/no-unsafe-assignment */
export type TestId = {
  testId: string;
  selector: string;
};

export const createTestId = (testId: string) => ({
  testId,
  selector: `[data-test-id="${testId}"]`,
});

/** Creates a test id object for popover elements */
export const createPopoverTestId = (testId: string) => ({
  testId,
  selector: `.ant-popover [data-test-id="${testId}"]`,
});
